'use client';

import Navigation from '@/components/layout/Navigation';
import { navigation } from '@/config/navigation';
import { cn } from '@/lib/ui/cn';
import { usePathname } from 'next/navigation';
import { PropsWithChildren } from 'react';

type HeaderProps = PropsWithChildren & {
  zenMode?: boolean;
  staticPositionining?: boolean;
};

const Header: React.FC<HeaderProps> = ({
  children,
  zenMode = false,
  staticPositionining = false,
}) => {
  const pathname = usePathname();

  return (
    <header
      data-test='header'
      className={cn(
        pathname === '/' ? 'fixed' : 'sticky',
        pathname === '/add-ons' ? 'sticky' : '',
        'inset-x-0 top-0 z-50',
        'flex flex-col items-stretch justify-between',
        staticPositionining && 'static'
      )}
    >
      <div>{children}</div>

      <Navigation zenMode={zenMode} items={navigation} />
    </header>
  );
};

export default Header;
